export const USER_IDLE_TIMEOUT = 1800000
